"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlankButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const utils_1 = require("../../utils");
/**
 * This button can be used to compose other buttons, it only handles styling without colors
 */
function ButtonComp(_a, ref) {
    var { className, as = 'button', disabled, roundedBorder = true, customBackground } = _a, props = __rest(_a, ["className", "as", "disabled", "roundedBorder", "customBackground"]);
    const [operatingSystem, setOperatingSystem] = (0, react_1.useState)('');
    const [browser, setBrowser] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        setBrowser((0, utils_1.getBrowser)());
        setOperatingSystem((0, utils_1.getOperatingSystem)());
    }, []);
    const styles = (0, classnames_1.default)('text-h200', 'font-bold', 'text-center', 'inline-flex', 'items-center', 'justify-center', {
        'rounded-md': roundedBorder,
        'pt-[3px]': operatingSystem === utils_1.OPERATING_SYSTEM.apple &&
            browser === utils_1.BROWSER.firefox
    }, className);
    if (as === 'a') {
        const _b = props, { children } = _b, linkProps = __rest(_b, ["children"]);
        return ((0, jsx_runtime_1.jsx)("a", Object.assign({ ref: ref, className: styles, disabled: disabled }, linkProps, { children: children })));
    }
    else if (as === 'submit') {
        const _c = props, { children } = _c, buttonProps = __rest(_c, ["children"]);
        return ((0, jsx_runtime_1.jsx)("button", Object.assign({ type: "submit", ref: ref, className: styles, disabled: disabled }, buttonProps, { children: children })));
    }
    const _d = props, { children } = _d, buttonProps = __rest(_d, ["children"]);
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ type: "button", ref: ref, className: styles, disabled: disabled }, buttonProps, { children: children })));
}
exports.BlankButton = (0, react_1.forwardRef)(ButtonComp);
//# sourceMappingURL=BlankButton.js.map